module.exports = __webpack_public_path__ + "static/media/Youtube.8f50bd5b.svg";